import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import JobsCompWrapper from "../../StylesWrappers/postJobsWrappers/allPostJobsCards";
import { JobPostCard } from "../allPostjobs";
import { AppDispatch, RootState } from "../../store";
import StatCardSkeleton from "../Skeletons/StatCardSkeleton";
import { ConfirmationModal } from "../General/helpers";
import { setCloseConfirmationModal } from "../../features/general/generalSlice";
import Overlay from "../General/overlay";
import Loader from "../General/Loader";

interface SaveForLaterProps {
  handleJobDetails: (saveForLaterId: string) => void;
  initialRemoveSaveForLater?: any;
  handleRemoveSaveForLater?: (_id: string) => void;
}

const SaveForLater = ({
  handleRemoveSaveForLater,
  initialRemoveSaveForLater,
  handleJobDetails,
}: SaveForLaterProps) => {
  const { saveForLater, isSaveForLaterLoading, isSaveDeleteLoading } =
    useSelector((store: RootState) => store.saveForLaterStore);
  const { openConfirmationModal } = useSelector(
    (store: RootState) => store.generalStore
  );

  const dispatch = useDispatch<AppDispatch>();

  if (isSaveForLaterLoading) {
    return <StatCardSkeleton />;
  }

  if (saveForLater?.length < 1) {
    return (
      <NoJobsWrapper>
        <p className="no__job">NO JOBS SAVED FOR LATER</p>
      </NoJobsWrapper>
    );
  }

  return (
    <>
      {isSaveDeleteLoading && (
        <Overlay>
          <Loader />
        </Overlay>
      )}
      <ConfirmationModal
        handleCloseModal={() => dispatch(setCloseConfirmationModal())}
        handleRemoveItem={handleRemoveSaveForLater}
        isOverlayModal={openConfirmationModal}
        modalMessage="Are you sure you want to remove this job"
      />

      <JobsCompWrapper>
        {saveForLater.map((each) => {
          const {
            _id,
            position,
            company,
            jobType,
            jobLocation,
            jobEmail,
            jobUrl,
            saveForLaterId,
          }: any = each;
          return (
            <JobPostCard
              key={_id}
              handleJobDetails={() => handleJobDetails(saveForLaterId)}
              initialSaveForLater={() => initialRemoveSaveForLater(_id)}
              position={position}
              company={company}
              jobType={jobType}
              jobLocation={jobLocation}
              jobEmail={jobEmail}
              jobUrl={jobUrl}
            />
          );
        })}
      </JobsCompWrapper>
    </>
  );
};

export default SaveForLater;

const NoJobsWrapper = styled.div`
  .no__job {
    font-size: 24px;
    font-weight: bold;
  }

  @media screen and (max-width: 650px) {
    .no__job {
      font-size: 18px;
    }
  }
`;
